// extracted by mini-css-extract-plugin
export default {"chip":"CreateOrderChip_chip__hT0Gk","label":"CreateOrderChip_label__YFeCS"};